import {KeycloakService} from 'keycloak-angular';
import {environment} from '../../environments/environment.dev';

export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloak.keycloakUrl,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
      },
      loadUserProfileAtStartUp: false,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: true
      },
      bearerExcludedUrls: []
    });
}
